import type { DocumentValue } from "../types";

type DocumentLike = Partial<DocumentValue> | null | undefined;

function getTrimmedString(value: unknown): string {
  return typeof value === "string" ? value.trim() : "";
}

export function getDocumentDescription(value: DocumentLike): string {
  return (
    getTrimmedString(value?.item_name) ||
    getTrimmedString(value?.description) ||
    getTrimmedString(value?.name)
  );
}

export function getExplicitDocumentDescription(value: DocumentLike): string {
  return getTrimmedString(value?.item_name) || getTrimmedString(value?.description);
}

export function getDocumentItemId(value: DocumentLike): number | undefined {
  const rawValue = value?.item_id ?? value?.id;
  if (rawValue === undefined || rawValue === null) return undefined;

  const numericValue = Number(rawValue);
  return Number.isFinite(numericValue) ? numericValue : undefined;
}

export function getDocumentSelectionLabel(value: DocumentLike): string {
  return (
    getDocumentDescription(value) ||
    getTrimmedString(value?.filename) ||
    getTrimmedString(value?.url)
  );
}
